import { createWithEqualityFn } from "zustand/traditional";
import { shallow } from "zustand/shallow";

interface LoginOTPInterface {
  userId: string | null;
  verificationType: string | null;
  setUrlParams: (userId: string | null, verificationType: string | null) => void;

  greetingFirstName: string;
  setGreetingFirstName: (value: string) => void;

  fixPaymentGiveawayHighlight: string;
  setFixPaymentGiveawayHighlight: (value: string) => void;

  handleVerifySuccess: (() => Promise<void>) | null;
  setHandleVerifySuccess: (value: (() => Promise<void>) | null) => void;

  resetStore: () => void;
}

const LoginOTPInterfaceStore = createWithEqualityFn<LoginOTPInterface>(
  (set) => ({
    userId: null,
    verificationType: null,
    setUrlParams: (userId, verificationType) => set({ userId, verificationType }),

    greetingFirstName: "there",
    setGreetingFirstName: (value) => set({ greetingFirstName: value }),

    fixPaymentGiveawayHighlight: "current giveaway",
    setFixPaymentGiveawayHighlight: (value) =>
      set({ fixPaymentGiveawayHighlight: value }),

    handleVerifySuccess: null,
    setHandleVerifySuccess: (value) => set({ handleVerifySuccess: value }),

    resetStore: () =>
      set({
        userId: null,
        verificationType: null,
        greetingFirstName: "there",
        fixPaymentGiveawayHighlight: "current giveaway",
        handleVerifySuccess: null,
      }),
  }),
  shallow
);

export default LoginOTPInterfaceStore;
